/**
 * create filters button
 *
 * @param {object} labels
 * @param {string} defaultFilter
 * @param {function} handlerFilter
 */
export const createFilter = (
  labels = {},
  defaultFilter,
  handlerFilter = () => {}
) => {
  const { filters } = labels;
  if (!filters) return;
  const container = document.createElement("div");
  container.classList.add("filters_container");
  Object.keys(filters).map(f => {
    // label
    const filterElement = document.createElement("label");
    filterElement.setAttribute("for", f);
    // div container
    const div = document.createElement("div");
    // input
    const input = document.createElement("input");
    input.setAttribute("type", "radio");
    input.value = f;
    input.name = "filter[]";
    input.id = f;
    input.addEventListener("click", handlerFilter);
    if (f === defaultFilter) {
      input.checked = true;
    }
    // span
    const span = document.createElement("span");
    span.textContent = filters[f];

    div.appendChild(input);
    div.appendChild(span);
    filterElement.appendChild(div);
    container.appendChild(filterElement);
  });
  return container;
};
